import getSkypeOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
import SkypeNotificationType from '../store/schema/SkypeNotificationType';

export default mutatorAction(
    'selectSkypeNotificationOption',
    function selectSkypeNotificationOption(
        notificationType: SkypeNotificationType,
        isImNotification: boolean
    ) {
        let optionState = getSkypeOptions();
        if (isImNotification) {
            optionState.imNotification = notificationType;
        } else {
            optionState.callNotification = notificationType;
        }
    }
);
